// extracted by mini-css-extract-plugin
module.exports = {"playerContainer":"Players_playerContainer__2dikV"};